import { FC } from 'react'
import classNames from 'classnames'
import { motion } from 'motion/react'

import { useArabicSessionLanguage } from '../../../global/context/SessionSettingsContext'
import { Tooltip } from '../../Popups/Tooltip/Tooltip'

import styles from './ProgressBar.module.scss'

export type Color = 'red' | 'blue'

export interface ProgressBarProps {
  color: Color
  percent: number | null
  tooltip: string | null
  isCurrent: boolean
  delay?: number
}

export const PROGRESS_BAR_DURATION = 0.5

export const ProgressBar: FC<ProgressBarProps> = (props) => {
  const { percent, color, tooltip, delay, isCurrent } = props
  const isArabic = useArabicSessionLanguage()

  return (
    <div className={styles.progressBar}>
      {(percent ?? 0) <= 0 && <div className={styles.isStrokedPlaceholder}></div>}

      <div
        dir={isArabic ? 'rtl' : 'ltr'}
        className={classNames(styles.progressBarSection, styles.isStroked)}
      />

      {((percent !== null && percent > 0) || (percent === 0 && isCurrent)) && (
        <Tooltip.New wrapperClassName={styles.tooltip} content={tooltip}>
          <motion.div
            className={classNames(styles.progressBarSection, styles[color])}
            initial={{ width: 0 }}
            animate={{ width: `${percent}%` }}
            transition={{
              duration: PROGRESS_BAR_DURATION,
              ease: 'easeOut',
              delay: delay ?? 0,
            }}
          />
        </Tooltip.New>
      )}
    </div>
  )
}
